import React from 'react';
import { Navigate } from 'react-router-dom';

function normalizeGroupName(name) {
  const base = (name || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return base.replace(/[_\s-]+/g, '').toLowerCase();
}

function hasSystemAccess(user) {
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  const groups = Array.isArray(user?.groups) ? user.groups : [];

  const hasRole = roles.some((r) => ['aprovador', 'comprador', 'devs', 'Desenvolvedores'].includes(r));
  if (hasRole) return true;

  return groups.some((g) => {
    const n = normalizeGroupName(g);
    return n.startsWith('req') || n.startsWith('aprovadores') || ['grupocompras', 'compradores', 'comprasconsulta', 'desenvolvedores'].includes(n);
  });
}

// Protege rotas verificando se há uma conta MSAL no sessionStorage
// Simples e sem dependências. Depois podemos integrar com MSAL React.
export default function ProtectedRoute({ children }) {
  // Verifica sessão somente em sessionStorage (tokens não devem persistir em localStorage)
  const hasSession = !!sessionStorage.getItem('msal.activeAccount');
  if (!hasSession) return <Navigate to="/login" replace />;

  try {
    const rawUser = sessionStorage.getItem('user');
    if (!rawUser) return <Navigate to="/login" replace />;
    const user = JSON.parse(rawUser);
    if (!hasSystemAccess(user)) {
      sessionStorage.clear();
      return <Navigate to="/login" replace />;
    }
  } catch {
    return <Navigate to="/login" replace />;
  }

  return children;
}
